
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CardHeading extends Vue {
  @Prop({ default: "Title Here" }) readonly title!: string;
}
